<qrcode [qrdata]="text ? text : 'error'" [width]="128" [errorCorrectionLevel]="'Q'" [elementType]="'svg'" [margin]="0"
    [colorDark]="'#006f3d'"></qrcode>
<span class="user-select-none">Zum Login ins WLAN</span>